import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import ComingSoon from 'cashup/components/ComingSoon.component';
import ReportsMainLayoutContainer from 'reports/Common/ReportsMainLayout';
import { Tables } from 'reports/consts';
import CashCardSplitClientTableContainer from 'reports/Payments/CashCardSplitClientTable';
import CashCardSplitStylistTable from 'reports/Payments/CashCardSplitStylistTable';

const ReportsProps = ['salesReport'];

class PaymentsLayout extends ReportsMainLayoutContainer {
  constructor(props) {
    super(props);
    this.state = {
      headerData: {
        name: 'Payments',
        items: [
          {
            id: Tables.ClientVisitsFrequency,
            name: 'Visits Frequency',
            onClick: () => {
              this.setTables(Tables.ClientVisitsFrequency);
            },
          },
          {
            id: Tables.CashCardSplitByClient,
            name: 'Cash/Card Split',
            onClick: () => {
              this.setTables(Tables.CashCardSplitByClient);
            },
          },
          {
            id: Tables.UniqueClientVisits,
            name: 'Unique Visits',
            onClick: () => {
              this.setTables(Tables.UniqueClientVisits);
            },
          },
        ],
      },
      title: '',
      shownTables: 0,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    return (
      <div className="has-protipbox payments">
        <ComingSoon variant="big" />
        <div className="new-wraper">
          {!this.checkIfAllDataIsLoaded() && (
            <div className="spinner-container">
              <div className="load-spinner" />
            </div>
          )}
          {this.props.salesReport.lastRequestResponse && (
            <div className="box">
              <div className="title">{`${this.state.title}`}</div>
              <CashCardSplitStylistTable
                startDate={moment(this.props.uniqueVisitsReport.start_date).format('D MMM YYYY')}
                endDate={moment(this.props.uniqueVisitsReport.end_date).format('D MMM YYYY')}
                dataCategory={this.props.salesReport.lastRequestResponse.category_group}
                dataProducts={this.props.salesReport.lastRequestResponse.product_group}
                stylists={this.props.salesReport.lastRequestResponse.stylist_group}
              />
              <CashCardSplitClientTableContainer
                startDate={moment(this.props.uniqueVisitsReport.start_date).format('D MMM YYYY')}
                endDate={moment(this.props.uniqueVisitsReport.end_date).format('D MMM YYYY')}
                dataCategory={this.props.salesReport.lastRequestResponse.category_group}
                dataProducts={this.props.salesReport.lastRequestResponse.product_group}
                clients={this.props.salesReport.lastRequestResponse.client_group}
              />

              {/* !!(this.state.shownTables & Tables.UniqueClientVisits) && (
              <UniqClientVisitsTableContainer
                dataCategory={this.props.salesReport.lastRequestResponse.category_group}
                dataProducts={this.props.salesReport.lastRequestResponse.product_group}
                stylists={this.props.salesReport.lastRequestResponse.stylist_group}
              />
            ) */}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const {
    currentSalon: { id: salonId },
    reports,
  } = state;
  const { salesReport, isFetching, uniqueVisitsReport } = reports;
  return {
    salonId,
    salesReport,
    isFetching,
    uniqueVisitsReport,
  };
}

export function mapDispatchToProps() {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentsLayout);
